import { Skeleton } from '../../components/skeleton';

const numberFormatter = new Intl.NumberFormat();

// Combined chronologies card showing fact and doc chronologies side by side.
export function ChronologyStatBlock({
  factChronologies,
  docChronologies,
}: {
  factChronologies?: number;
  docChronologies?: number;
}) {
  const isLoading = factChronologies === undefined || docChronologies === undefined;

  return (
    <div className="flex min-w-min flex-col justify-between gap-2 rounded-lg border bg-gray-50 p-4">
      <p className="text-xs font-medium tracking-wider text-gray-500 uppercase">Chronologies</p>
      <div className="flex h-9 items-baseline gap-6">
        {isLoading ? (
          <>
            <Skeleton className="h-7 w-12 self-center bg-gray-200/70" />
            <Skeleton className="h-7 w-12 self-center bg-gray-200/70" />
          </>
        ) : (
          <>
            <div className="flex items-baseline gap-1.5">
              <span className="animate-in fade-in text-3xl font-semibold tracking-tight text-gray-900 tabular-nums">
                {numberFormatter.format(factChronologies)}
              </span>
              <span className="text-xs text-gray-500">fact</span>
            </div>
            <div className="flex items-baseline gap-1.5">
              <span className="animate-in fade-in text-3xl font-semibold tracking-tight text-gray-900 tabular-nums">
                {numberFormatter.format(docChronologies)}
              </span>
              <span className="text-xs text-gray-500">doc</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
